const map = {
	"./back_to_top": 70473,
	"./back_to_top.svg": 70473,
	"./d-made-with-love-meant-to-last": 52375,
	"./d-made-with-love-meant-to-last.svg": 52375,
	"./d-truck": 45056,
	"./d-truck.svg": 45056,
	"./d-tt-the-perfect-gift-au-uk": 38992,
	"./d-tt-the-perfect-gift-au-uk.svg": 38992,
	"./d-tt-the-perfect-gift-us-ca": 6074,
	"./d-tt-the-perfect-gift-us-ca.svg": 6074,
	"./extra-20-off": 95903,
	"./extra-20-off-desktop": 69584,
	"./extra-20-off-desktop.svg": 69584,
	"./extra-20-off-mobile": 44174,
	"./extra-20-off-mobile.svg": 44174,
	"./extra-20-off.svg": 95903,
	"./footer/connect/blog": 80631,
	"./footer/connect/blog.svg": 80631,
	"./footer/connect/facebook": 16703,
	"./footer/connect/facebook.svg": 16703,
	"./footer/connect/facebook_v2": 48010,
	"./footer/connect/facebook_v2.svg": 48010,
	"./footer/connect/facebook_v3": 8379,
	"./footer/connect/facebook_v3.svg": 8379,
	"./footer/connect/googleplus": 65226,
	"./footer/connect/googleplus.svg": 65226,
	"./footer/connect/instagram": 91381,
	"./footer/connect/instagram.svg": 91381,
	"./footer/connect/instagram_v2": 20472,
	"./footer/connect/instagram_v2.svg": 20472,
	"./footer/connect/instagram_v3": 95977,
	"./footer/connect/instagram_v3.svg": 95977,
	"./footer/connect/pinterest": 67887,
	"./footer/connect/pinterest.svg": 67887,
	"./footer/connect/pinterest_v2": 11386,
	"./footer/connect/pinterest_v2.svg": 11386,
	"./footer/connect/pinterest_v3": 88907,
	"./footer/connect/pinterest_v3.svg": 88907,
	"./footer/connect/tiktok": 72973,
	"./footer/connect/tiktok-lf": 44888,
	"./footer/connect/tiktok-lf.svg": 44888,
	"./footer/connect/tiktok.svg": 72973,
	"./footer/connect/tiktok_v2": 71504,
	"./footer/connect/tiktok_v2.svg": 71504,
	"./footer/connect/tiktok_v3": 62625,
	"./footer/connect/tiktok_v3.svg": 62625,
	"./footer/connect/twitter": 20504,
	"./footer/connect/twitter.svg": 20504,
	"./footer/connect/youtube": 63774,
	"./footer/connect/youtube.svg": 63774,
	"./footer/connect/youtube_v2": 82657,
	"./footer/connect/youtube_v2.svg": 82657,
	"./footer/connect/youtube_v3": 70416,
	"./footer/connect/youtube_v3.svg": 70416,
	"./footer/payment/Amex": 21854,
	"./footer/payment/Amex.svg": 21854,
	"./footer/payment/BBB": 38011,
	"./footer/payment/BBB.svg": 38011,
	"./footer/payment/CJA": 74122,
	"./footer/payment/CJA.png": 74122,
	"./footer/payment/JVC": 67654,
	"./footer/payment/JVC.svg": 67654,
	"./footer/payment/VISA": 16099,
	"./footer/payment/VISA.png": 16099,
	"./footer/payment/VISA.svg": 78484,
	"./footer/payment/chat_bubble": 49717,
	"./footer/payment/chat_bubble.svg": 49717,
	"./footer/payment/discover": 1694,
	"./footer/payment/discover.svg": 1694,
	"./footer/payment/klarna-grey": 55176,
	"./footer/payment/klarna-grey.svg": 55176,
	"./footer/payment/klarna-white": 58456,
	"./footer/payment/klarna-white.svg": 58456,
	"./footer/payment/mastercard": 57123,
	"./footer/payment/mastercard.svg": 57123,
	"./footer/payment/payment acreddited bus": 48284,
	"./footer/payment/payment acreddited bus.svg": 48284,
	"./footer/payment/paypal": 89902,
	"./footer/payment/paypal.svg": 89902,
	"./footer/payment/trustwave": 71744,
	"./footer/payment/trustwave.svg": 71744,
	"./footer/perks/1-year-warranty": 61638,
	"./footer/perks/1-year-warranty.svg": 61638,
	"./footer/perks/99-day-returns": 61437,
	"./footer/perks/99-day-returns.svg": 61437,
	"./footer/perks/99dayreturn": 29701,
	"./footer/perks/99dayreturn-grey": 22790,
	"./footer/perks/99dayreturn-grey.svg": 22790,
	"./footer/perks/99dayreturn.png": 29701,
	"./footer/perks/99dayreturn.svg": 33594,
	"./footer/perks/diamond": 38864,
	"./footer/perks/diamond.svg": 38864,
	"./footer/perks/free-express": 64365,
	"./footer/perks/free-express.svg": 64365,
	"./footer/perks/free-gift": 39757,
	"./footer/perks/free-gift-with-purchase": 2486,
	"./footer/perks/free-gift-with-purchase.svg": 2486,
	"./footer/perks/free-gift.svg": 39757,
	"./footer/perks/free-resizing": 51262,
	"./footer/perks/free-resizing.svg": 51262,
	"./footer/perks/free-shipping": 69969,
	"./footer/perks/free-shipping.svg": 69969,
	"./footer/perks/freegift": 82175,
	"./footer/perks/freegift-grey": 2864,
	"./footer/perks/freegift-grey.svg": 2864,
	"./footer/perks/freegift.png": 82175,
	"./footer/perks/freegift.svg": 10448,
	"./footer/perks/freeresizing": 72356,
	"./footer/perks/freeresizing.png": 72356,
	"./footer/perks/freeresizing.svg": 52003,
	"./footer/perks/freeshipping": 55799,
	"./footer/perks/freeshipping-grey": 7272,
	"./footer/perks/freeshipping-grey.svg": 7272,
	"./footer/perks/freeshipping.png": 55799,
	"./footer/perks/freeshipping.svg": 91992,
	"./footer/perks/lifetime-warranty": 14458,
	"./footer/perks/lifetime-warranty.svg": 14458,
	"./footer/perks/made-in-north-america": 52772,
	"./footer/perks/made-in-north-america.svg": 52772,
	"./footer/perks/madein": 28857,
	"./footer/perks/madein.png": 28857,
	"./footer/perks/madein.svg": 74286,
	"./footer/perks/one-year-warranty": 13239,
	"./footer/perks/one-year-warranty-icon": 74635,
	"./footer/perks/one-year-warranty-icon.svg": 74635,
	"./footer/perks/one-year-warranty.svg": 13239,
	"./footer/perks/premium-gift": 87578,
	"./footer/perks/premium-gift.svg": 87578,
	"./footer/perks/returns": 5897,
	"./footer/perks/returns.svg": 5897,
	"./footer/perks/shipping": 86626,
	"./footer/perks/shipping.svg": 86626,
	"./footer/perks/warranty": 53971,
	"./footer/perks/warranty-grey": 48084,
	"./footer/perks/warranty-grey.svg": 48084,
	"./footer/perks/warranty.png": 53971,
	"./footer/perks/warranty.svg": 83876,
	"./footer/perks/white/free-resizing": 3304,
	"./footer/perks/white/free-resizing.svg": 3304,
	"./footer/perks/white/free-shipping": 65067,
	"./footer/perks/white/free-shipping.svg": 65067,
	"./footer/perks/white/made-in-north-america": 23002,
	"./footer/perks/white/made-in-north-america.svg": 23002,
	"./footer/perks/white/one-year-warranty": 1025,
	"./footer/perks/white/one-year-warranty.svg": 1025,
	"./footer/perks/white/returns": 46335,
	"./footer/perks/white/returns.svg": 46335,
	"./header/cart_blue": 70897,
	"./header/cart_blue.svg": 70897,
	"./header/cart_blue_old": 83123,
	"./header/cart_blue_old.svg": 83123,
	"./header/cart_darkblue": 51929,
	"./header/cart_darkblue.svg": 51929,
	"./header/cart_primary": 76549,
	"./header/cart_primary.svg": 76549,
	"./header/cart_white": 46736,
	"./header/cart_white.svg": 46736,
	"./header/close_blue": 74095,
	"./header/close_blue.svg": 74095,
	"./header/close_search_mobile": 31323,
	"./header/close_search_mobile.png": 31323,
	"./header/country/ca": 22193,
	"./header/country/ca.svg": 22193,
	"./header/country/us": 74433,
	"./header/country/us.svg": 74433,
	"./header/easter/default/top_menu_adblock": 83210,
	"./header/easter/default/top_menu_adblock.jpg": 83210,
	"./header/easter/default/top_menu_adblock@2x": 83746,
	"./header/easter/default/top_menu_adblock@2x.jpg": 83746,
	"./header/easter/eu_au/top_menu_adblock": 53822,
	"./header/easter/eu_au/top_menu_adblock.jpg": 53822,
	"./header/easter/eu_au/top_menu_adblock@2x": 21198,
	"./header/easter/eu_au/top_menu_adblock@2x.jpg": 21198,
	"./header/envelope": 53168,
	"./header/envelope.svg": 53168,
	"./header/everyday_explore": 25586,
	"./header/everyday_explore.jpg": 25586,
	"./header/everyday_explore_2x": 95797,
	"./header/everyday_explore_2x.jpg": 95797,
	"./header/fast-shipping": 93902,
	"./header/fast-shipping-black": 67967,
	"./header/fast-shipping-black.svg": 67967,
	"./header/fast-shipping.svg": 93902,
	"./header/heart_blue": 68047,
	"./header/heart_blue.svg": 68047,
	"./header/heart_white": 65162,
	"./header/heart_white.svg": 65162,
	"./header/login_blue": 15366,
	"./header/login_blue.svg": 15366,
	"./header/login_darkblue": 97706,
	"./header/login_darkblue.svg": 97706,
	"./header/login_white": 42933,
	"./header/login_white.svg": 42933,
	"./header/mothers_day/default/menu_adblock": 46457,
	"./header/mothers_day/default/menu_adblock.jpg": 46457,
	"./header/mothers_day/default/menu_adblock@2x": 15323,
	"./header/mothers_day/default/menu_adblock@2x.jpg": 15323,
	"./header/mothers_day/default/mothers_menu_adblock": 13726,
	"./header/mothers_day/default/mothers_menu_adblock.jpg": 13726,
	"./header/mothers_day/default/mothers_menu_adblock@2x": 61742,
	"./header/mothers_day/default/mothers_menu_adblock@2x.jpg": 61742,
	"./header/mothers_day/default/top_menu_adblock": 43197,
	"./header/mothers_day/default/top_menu_adblock.jpg": 43197,
	"./header/mothers_day/default/top_menu_adblock@2x": 69831,
	"./header/mothers_day/default/top_menu_adblock@2x.jpg": 69831,
	"./header/mothers_day/eu_au/menu_adblock": 7029,
	"./header/mothers_day/eu_au/menu_adblock.jpg": 7029,
	"./header/mothers_day/eu_au/menu_adblock@2x": 9727,
	"./header/mothers_day/eu_au/menu_adblock@2x.jpg": 9727,
	"./header/mothers_day/eu_au/mothers_menu_adblock": 55938,
	"./header/mothers_day/eu_au/mothers_menu_adblock.jpg": 55938,
	"./header/mothers_day/eu_au/mothers_menu_adblock@2x": 75514,
	"./header/mothers_day/eu_au/mothers_menu_adblock@2x.jpg": 75514,
	"./header/mothers_day/eu_au/top_menu_adblock": 10209,
	"./header/mothers_day/eu_au/top_menu_adblock.jpg": 10209,
	"./header/mothers_day/eu_au/top_menu_adblock@2x": 95491,
	"./header/mothers_day/eu_au/top_menu_adblock@2x.jpg": 95491,
	"./header/mothersday_reg/default/menu_adblock": 57735,
	"./header/mothersday_reg/default/menu_adblock.jpg": 57735,
	"./header/mothersday_reg/default/menu_adblock@2x": 40609,
	"./header/mothersday_reg/default/menu_adblock@2x.jpg": 40609,
	"./header/mothersday_reg/default/mothers_menu_adblock": 33884,
	"./header/mothersday_reg/default/mothers_menu_adblock.jpg": 33884,
	"./header/mothersday_reg/default/mothers_menu_adblock@2x": 98884,
	"./header/mothersday_reg/default/mothers_menu_adblock@2x.jpg": 98884,
	"./header/mothersday_reg/default/top_menu_adblock": 52291,
	"./header/mothersday_reg/default/top_menu_adblock.jpg": 52291,
	"./header/mothersday_reg/default/top_menu_adblock@2x": 28805,
	"./header/mothersday_reg/default/top_menu_adblock@2x.jpg": 28805,
	"./header/mothersday_reg/eu_au/menu_adblock": 37704,
	"./header/mothersday_reg/eu_au/menu_adblock.jpg": 37704,
	"./header/mothersday_reg/eu_au/menu_adblock@2x": 47325,
	"./header/mothersday_reg/eu_au/menu_adblock@2x.jpg": 47325,
	"./header/mothersday_reg/eu_au/mothers_menu_adblock": 20536,
	"./header/mothersday_reg/eu_au/mothers_menu_adblock.jpg": 20536,
	"./header/mothersday_reg/eu_au/mothers_menu_adblock@2x": 69416,
	"./header/mothersday_reg/eu_au/mothers_menu_adblock@2x.jpg": 69416,
	"./header/mothersday_reg/eu_au/top_menu_adblock": 14799,
	"./header/mothersday_reg/eu_au/top_menu_adblock.jpg": 14799,
	"./header/mothersday_reg/eu_au/top_menu_adblock@2x": 79881,
	"./header/mothersday_reg/eu_au/top_menu_adblock@2x.jpg": 79881,
	"./header/search_black": 43788,
	"./header/search_black.svg": 43788,
	"./header/search_blue": 18671,
	"./header/search_blue.svg": 18671,
	"./header/search_white": 22634,
	"./header/search_white.svg": 22634,
	"./header/vday_guide_adblock": 93241,
	"./header/vday_guide_adblock (copy)": 59985,
	"./header/vday_guide_adblock (copy).jpg": 59985,
	"./header/vday_guide_adblock.jpg": 93241,
	"./loadinglarge": 34395,
	"./loadinglarge.gif": 34395,
	"./logo/2024_Jewlr_Logo": 5867,
	"./logo/2024_Jewlr_Logo.svg": 5867,
	"./logo/black/JEWLR_LOGO_AU": 64745,
	"./logo/black/JEWLR_LOGO_AU.svg": 64745,
	"./logo/black/JEWLR_LOGO_CA": 40723,
	"./logo/black/JEWLR_LOGO_CA.svg": 40723,
	"./logo/black/JEWLR_LOGO_DE": 31982,
	"./logo/black/JEWLR_LOGO_DE.svg": 31982,
	"./logo/black/JEWLR_LOGO_ES": 81619,
	"./logo/black/JEWLR_LOGO_ES.svg": 81619,
	"./logo/black/JEWLR_LOGO_EU": 93645,
	"./logo/black/JEWLR_LOGO_EU.svg": 93645,
	"./logo/black/JEWLR_LOGO_FR": 58331,
	"./logo/black/JEWLR_LOGO_FR.svg": 58331,
	"./logo/black/JEWLR_LOGO_IT": 36896,
	"./logo/black/JEWLR_LOGO_IT.svg": 36896,
	"./logo/black/JEWLR_LOGO_NL": 67941,
	"./logo/black/JEWLR_LOGO_NL.svg": 67941,
	"./logo/black/JEWLR_LOGO_UK": 40875,
	"./logo/black/JEWLR_LOGO_UK.svg": 40875,
	"./logo/black/JEWLR_LOGO_US": 88707,
	"./logo/black/JEWLR_LOGO_US.svg": 88707,
	"./logo/jewlr-icon-logo": 21292,
	"./logo/jewlr-icon-logo-primary": 62321,
	"./logo/jewlr-icon-logo-primary.svg": 62321,
	"./logo/jewlr-icon-logo-white": 72540,
	"./logo/jewlr-icon-logo-white.svg": 72540,
	"./logo/jewlr-icon-logo.svg": 21292,
	"./logo/jewlr-logo": 77178,
	"./logo/jewlr-logo-white": 8982,
	"./logo/jewlr-logo-white.svg": 8982,
	"./logo/jewlr-logo.svg": 77178,
	"./logo/white/JEWLR_LOGO_AU": 75099,
	"./logo/white/JEWLR_LOGO_AU.svg": 75099,
	"./logo/white/JEWLR_LOGO_CA": 59305,
	"./logo/white/JEWLR_LOGO_CA.svg": 59305,
	"./logo/white/JEWLR_LOGO_DE": 74136,
	"./logo/white/JEWLR_LOGO_DE.svg": 74136,
	"./logo/white/JEWLR_LOGO_ES": 24713,
	"./logo/white/JEWLR_LOGO_ES.svg": 24713,
	"./logo/white/JEWLR_LOGO_EU": 9655,
	"./logo/white/JEWLR_LOGO_EU.svg": 9655,
	"./logo/white/JEWLR_LOGO_FR": 78781,
	"./logo/white/JEWLR_LOGO_FR.svg": 78781,
	"./logo/white/JEWLR_LOGO_IT": 7426,
	"./logo/white/JEWLR_LOGO_IT.svg": 7426,
	"./logo/white/JEWLR_LOGO_NL": 34003,
	"./logo/white/JEWLR_LOGO_NL.svg": 34003,
	"./logo/white/JEWLR_LOGO_UK": 97041,
	"./logo/white/JEWLR_LOGO_UK.svg": 97041,
	"./logo/white/JEWLR_LOGO_US": 96953,
	"./logo/white/JEWLR_LOGO_US.svg": 96953,
	"./m-made-with-love-meant-to-last": 30840,
	"./m-made-with-love-meant-to-last.svg": 30840,
	"./m-tt-the-perfect-gift-au-uk": 76081,
	"./m-tt-the-perfect-gift-au-uk.svg": 76081,
	"./m-tt-the-perfect-gift-us-ca": 45051,
	"./m-tt-the-perfect-gift-us-ca.svg": 45051,
	"./nav/dailydeals_bow": 10157,
	"./nav/dailydeals_bow.svg": 10157,
	"./nav/mm-mega-deals": 2360,
	"./nav/mm-mega-deals-60": 95649,
	"./nav/mm-mega-deals-60.jpg": 95649,
	"./nav/mm-mega-deals-60_2x": 33508,
	"./nav/mm-mega-deals-60_2x.jpg": 33508,
	"./nav/mm-mega-deals-ny": 74532,
	"./nav/mm-mega-deals-ny.jpg": 74532,
	"./nav/mm-mega-deals-ny_2x": 31355,
	"./nav/mm-mega-deals-ny_2x.jpg": 31355,
	"./nav/mm-mega-deals-summer": 99232,
	"./nav/mm-mega-deals-summer.jpg": 99232,
	"./nav/mm-mega-deals-summer_2x": 43975,
	"./nav/mm-mega-deals-summer_2x.jpg": 43975,
	"./nav/mm-mega-deals-valentines": 53622,
	"./nav/mm-mega-deals-valentines.jpg": 53622,
	"./nav/mm-mega-deals-valentines_2x": 42889,
	"./nav/mm-mega-deals-valentines_2x.jpg": 42889,
	"./nav/mm-mega-deals-winter": 21372,
	"./nav/mm-mega-deals-winter.jpg": 21372,
	"./nav/mm-mega-deals-winter_2x": 77443,
	"./nav/mm-mega-deals-winter_2x.jpg": 77443,
	"./nav/mm-mega-deals.jpg": 2360,
	"./nav/mm-mega-deals_2x": 8975,
	"./nav/mm-mega-deals_2x.jpg": 8975,
	"./nav/mm-shop-for-her": 51960,
	"./nav/mm-shop-for-her-summer": 9952,
	"./nav/mm-shop-for-her-summer.jpg": 9952,
	"./nav/mm-shop-for-her-summer_2x": 24295,
	"./nav/mm-shop-for-her-summer_2x.jpg": 24295,
	"./nav/mm-shop-for-her-winter": 32092,
	"./nav/mm-shop-for-her-winter.jpg": 32092,
	"./nav/mm-shop-for-her-winter_2x": 41411,
	"./nav/mm-shop-for-her-winter_2x.jpg": 41411,
	"./nav/mm-shop-for-her.jpg": 51960,
	"./nav/mm-shop-for-her_2x": 64783,
	"./nav/mm-shop-for-her_2x.jpg": 64783,
	"./nav/mm-shop-for-him": 18831,
	"./nav/mm-shop-for-him-summer": 95861,
	"./nav/mm-shop-for-him-summer.jpg": 95861,
	"./nav/mm-shop-for-him-summer_2x": 25080,
	"./nav/mm-shop-for-him-summer_2x.jpg": 25080,
	"./nav/mm-shop-for-him-winter": 25129,
	"./nav/mm-shop-for-him-winter.jpg": 25129,
	"./nav/mm-shop-for-him-winter_2x": 5820,
	"./nav/mm-shop-for-him-winter_2x.jpg": 5820,
	"./nav/mm-shop-for-him.jpg": 18831,
	"./nav/mm-shop-for-him_2x": 40550,
	"./nav/mm-shop-for-him_2x.jpg": 40550,
	"./nav/mm-valentines-for-her": 27757,
	"./nav/mm-valentines-for-her.jpg": 27757,
	"./nav/mm-valentines-for-her_2x": 75424,
	"./nav/mm-valentines-for-her_2x.jpg": 75424,
	"./nav/mm-valentines-for-him": 85242,
	"./nav/mm-valentines-for-him.jpg": 85242,
	"./nav/mm-valentines-for-him_2x": 26925,
	"./nav/mm-valentines-for-him_2x.jpg": 26925,
	"./nav/myaccount": 15083,
	"./nav/myaccount.svg": 15083,
	"./nav/myaccount_blue": 50054,
	"./nav/myaccount_blue.svg": 50054,
	"./nav/myorders": 56861,
	"./nav/myorders.svg": 56861,
	"./nav/myorders_blue": 556,
	"./nav/myorders_blue.svg": 556
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35115;